import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download_production/690a84b88dff8b00147a053c_1782715083340_01ff6473/neuroakashic_light_ambassadors/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/690a84b88dff8b00147a053c_1782715083340_01ff6473/neuroakashic_light_ambassadors/src/styles/index.css");
